import styled, { keyframes } from 'styled-components';
import { device, radius } from '@/styles/template';

const slideUp = keyframes`
    0%   { transform: translateY(110%); opacity: 0; }
    70%  { transform: translateY(-4px); opacity: 1; }
    100% { transform: translateY(0);    opacity: 1; }
`;

// pointer-events: none — слой прозрачен для кликов, страница под ним остаётся
// интерактивной. Кликабельна только SnackbarBox (pointer-events: auto).
export const SnackbarViewport = styled.div`
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    display: flex;
    justify-content: center;
    // Отступ всей плашки от краёв вьюпорта на мобиле (не внутренний padding).
    padding: 0 ${({ theme }) => theme.primitives?.spacing?.[3] ?? '3rem'};
    pointer-events: none;
`;

export const SnackbarBox = styled.div`
    pointer-events: auto;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.primitives?.spacing?.[2] ?? '2rem'};
    padding: ${({ theme }) => theme.primitives?.spacing?.[2] ?? '2rem'};

    // В светлой теме — white из токенов (surface.primary), в тёмной — фон поверхности.
    background: ${({ theme }) => theme.title === 'light'
        ? theme.semantic.surface.primary
        : theme.semantic.surface.background};
    color: ${({ theme }) => theme.semantic.text.primary};
    box-shadow: ${({ theme }) => theme.semantic.elevation.modal};

    width: 100%;
    max-width: 480px;
    margin-bottom: 10rem;
    border-radius: ${({ theme }) => theme.primitives?.radius?.lg ?? radius.large};

    animation: ${slideUp} .45s cubic-bezier(0.280, 0.840, 0.420, 1);

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }

    @media ${device.tablet} {
        width: auto;
    }
`;

export const SnackbarContent = styled.div`
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: ${({ theme }) => theme.primitives?.spacing?.[1] ?? '1rem'};
`;

export const SnackbarCloseWrap = styled.div`
    flex: 0 0 auto;
    display: flex;
`;
